/**
 * Refusals of the endpoints that change who signs a document or replace its
 * file (dokobit/create, dokobit/add-signer, dokobit/remove-signer,
 * click-to-sign/assign, click-to-sign/add-signer, click-to-sign/remove-signer,
 * signature/add-signers, signatures/signontab/upload,
 * files/manual-signed-document-upload):
 * - HTTP 400 `{ message }` with one of the codes below — each code is also its
 *   translation key;
 * - a bare HTTP 403 (body "Forbidden") when the person neither owns the
 *   document nor holds a document-managing right.
 */
const SIGNER_EDIT_REFUSALS = [
  "document_file_empty", // dokobit/create: the stored PDF is empty
  "document_signed",
  "signatures_collected",
  "replacement_not_fresh_upload",
];

export const SIGNER_EDIT_FORBIDDEN = "signer_edit_forbidden";

/**
 * Translation key to show for a failed signer change: the refusal's own text
 * when the server gave one of the reasons above, otherwise `fallbackKey`.
 */
export function signerEditErrorKey(error: any, fallbackKey: string): string {
  if (error?.response?.status === 403) return SIGNER_EDIT_FORBIDDEN;
  const message = error?.response?.data?.message;
  return SIGNER_EDIT_REFUSALS.includes(message) ? message : fallbackKey;
}
